/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import type { ISocialChannel } from '../social-channel-schema';
import { socialChannelSchema } from '../social-channel-schema';

const listDataSchema = z.object({
  items: z.array(socialChannelSchema),
});

export interface IListSocialChannelsV1Data {
  items: ISocialChannel[];
}

export const listSocialChannelsV1ResponseSchema = createApiResponseSchema(
  listDataSchema,
) as z.ZodSchema<IAPI<IListSocialChannelsV1Data>>;

export type IListSocialChannelsV1Response = IAPI<IListSocialChannelsV1Data>;
